/*
  On iOS platform, a synchronos persistent r/w is not available. Previous stored values are
  passed in as deviceState. The deviceState is used to restore the initial state of the app. 
  After a save or delete operation, reading from the deviceState is no longer allowed since 
  it does no longer represent the current stored state.
 */
export default class iOSStorageGateway {
  constructor(deviceState) {
    this.deviceState = deviceState;
    this.hasMutated = false;
  }

  save(key, value) {
    const data = {
      key: key,
      value: value,
    };

    if (!isStorageAvailable()) {
      console.error('Missing messageHandler, failed to store key: ' + key); // eslint-disable-line no-console
      return;
    }

    this.hasMutated = true;
    window.webkit.messageHandlers.storage.postMessage(JSON.stringify(data));
  }

  delete(key) {
    const data = {
      key: key,
      value: null,
    };

    if (!isStorageAvailable()) {
      console.error('Missing messageHandler, failed to delete key: ' + key); // eslint-disable-line no-console
      return;
    }

    this.hasMutated = true;
    window.webkit.messageHandlers.storage.postMessage(JSON.stringify(data));
  }

  getInitialState(key) {
    if (this.hasMutated) {
      throw "can't read state after it has been mutated.";
    }

    if (!this.deviceState || !this.deviceState[key]) {
      return;
    }

    return this.deviceState[key];
  }
}

function isStorageAvailable() {
  return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.storage;
}
